import { c as _c } from "react-compiler-runtime";
import { Flex } from 'foundations-components/components/Flex';
import { useSelectionSelector } from '../../redux/reduxHooks';
import BulkActionsContainer from '../../selection/components/BulkActionsContainer';
import { getShouldShowBulkActionsContainer } from '../../selection/redux/selectionSlice';
import { TABLE_TOP_BAR_HEIGHT } from '../constants/sizes';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TableTopBar(t0) {
  const $ = _c(16);
  const {
    alternateHeaderLeftSlot,
    BulkActionsComponent,
    headerLeftSlot,
    headerRightSlot,
    isBulkActionsRedesignEnabled,
    isIndexRedesignEnabled,
    showSelectQuery,
    totalRowCount,
    hasTopBarBorderRadius
  } = t0;
  const shouldShowBulkActions = useSelectionSelector(getShouldShowBulkActionsContainer);
  const shouldOnlyShowBulkActions = shouldShowBulkActions && isBulkActionsRedesignEnabled;
  const t1 = hasTopBarBorderRadius !== false ? "300" : undefined;
  const t2 = hasTopBarBorderRadius !== false ? "300" : undefined;
  const t3 = isBulkActionsRedesignEnabled ? "space-between" : "start";
  let t4;
  if ($[0] !== BulkActionsComponent || $[1] !== alternateHeaderLeftSlot || $[2] !== headerLeftSlot || $[3] !== headerRightSlot || $[4] !== isBulkActionsRedesignEnabled || $[5] !== isIndexRedesignEnabled || $[6] !== shouldOnlyShowBulkActions || $[7] !== shouldShowBulkActions || $[8] !== showSelectQuery || $[9] !== totalRowCount) {
    t4 = shouldOnlyShowBulkActions ? /*#__PURE__*/_jsx(BulkActionsContainer, {
      BulkActionsComponent: BulkActionsComponent,
      isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
      isIndexRedesignEnabled: isIndexRedesignEnabled,
      showSelectQuery: showSelectQuery,
      totalRowCount: totalRowCount
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [headerLeftSlot, !shouldShowBulkActions && alternateHeaderLeftSlot, shouldShowBulkActions && /*#__PURE__*/_jsx(BulkActionsContainer, {
        BulkActionsComponent: BulkActionsComponent,
        isBulkActionsRedesignEnabled: isBulkActionsRedesignEnabled,
        isIndexRedesignEnabled: isIndexRedesignEnabled,
        showSelectQuery: showSelectQuery,
        totalRowCount: totalRowCount
      }), /*#__PURE__*/_jsx(View, {
        marginInlineStart: "auto",
        as: "div",
        children: headerRightSlot
      })]
    });
    $[0] = BulkActionsComponent;
    $[1] = alternateHeaderLeftSlot;
    $[2] = headerLeftSlot;
    $[3] = headerRightSlot;
    $[4] = isBulkActionsRedesignEnabled;
    $[5] = isIndexRedesignEnabled;
    $[6] = shouldOnlyShowBulkActions;
    $[7] = shouldShowBulkActions;
    $[8] = showSelectQuery;
    $[9] = totalRowCount;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = /*#__PURE__*/_jsx(Flex, {
      alignItems: "center",
      backgroundColor: "fill-field-default",
      blockSize: TABLE_TOP_BAR_HEIGHT,
      borderColor: "border-core-subtle",
      borderStyle: "solid",
      borderWidth: "100",
      borderBlockEndStyle: "none",
      borderStartStartRadius: t1,
      borderStartEndRadius: t2,
      "data-test-id": "table-top-bar",
      flexBasis: TABLE_TOP_BAR_HEIGHT,
      inlineSize: "100%",
      justifyContent: t3,
      paddingInline: "100",
      children: t4
    });
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}
export default TableTopBar;